// extracted by mini-css-extract-plugin
export default {"checkbox":"AddNewPackModal_checkbox__dnvkT","button":"AddNewPackModal_button__25I6j"};